import React from 'react'
import withStyles from 'isomorphic-style-loader/withStyles'
import AdviserProfileInvestmentMinimums from '../../../../../common/AdviserProfiles/AdviserProfileInvestmentMinimums'
import * as styles from './_AdviserProfileInvestmentMinimumsEditor.scss'
import FieldGroup from '../../../../../common/forms/FieldGroup'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import {
  startEditingInvestmentMinimums
  , stopEditingInvestmentMinimums
  , setMinimumLumpSum
  , setMinimumMonthlyDebitOrder
  , setAllowUnsureInvestors
  , cancelEditingAdviserProfileInvestmentMinimums
} from '../../AdviserProfile/AdviserProfileInvestmentMinimumsEditor/adviserProfileInvestmentMinimumsEditorActions'
import { FormCheck } from 'react-bootstrap'
import PropTypes from 'prop-types';

class AdviserProfileInvestmentMinimumsEditor extends React.Component {
  static propTypes = {
    profile: PropTypes.object.isRequired,
    oldProfile: PropTypes.object.isRequired,
    editing: PropTypes.bool.isRequired,
    loading: PropTypes.bool.isRequired,
    startEditing: PropTypes.func.isRequired,
    stopEditing: PropTypes.func.isRequired,
    setMinimumLumpSum: PropTypes.func.isRequired,
    setMinimumMonthlyDebitOrder: PropTypes.func.isRequired,
    setAllowUnsureInvestors: PropTypes.func.isRequired,
    cancelEditingAdviserProfileInvestmentMinimums: PropTypes.func.isRequired,
    formIsValid: PropTypes.bool.isRequired,
    validationstate: PropTypes.object.isRequired
  }

  componentDidMount () {
    this.setState({})
  }

  constructor (props) {
    super(props)
    this.renderPreview = this.renderPreview.bind(this)
    this.renderEditor = this.renderEditor.bind(this)
    this.handleToggleAllowUnsureInvestors = this.handleToggleAllowUnsureInvestors.bind(this)
  }

  renderPreview () {
    const { oldProfile, profile } = this.props

    var modifiedDebitOrder = profile.investmentMinimums.minimumMonthlyDebitOrder !== (oldProfile.investmentMinimums ? oldProfile.investmentMinimums.minimumMonthlyDebitOrder : 0)
    var modifiedLumpSum = profile.investmentMinimums.minimumLumpSum !== (oldProfile.investmentMinimums ? oldProfile.investmentMinimums.minimumLumpSum : 0)
    return <AdviserProfileInvestmentMinimums
      investmentMinimums={profile.investmentMinimums}
      modifiedDebitOrder={modifiedDebitOrder}
      modifiedLumpSum={modifiedLumpSum} />
  }

  handleMinimumLumpSumChange = (value) => {
    this.props.setMinimumLumpSum(value)
  }

  handleMinimumMonthlyDebitOrderChange = (value) => {
    this.props.setMinimumMonthlyDebitOrder(value)
  }

  handleToggleAllowUnsureInvestors (value) {
    this.props.setAllowUnsureInvestors(value)
  }

  renderEditor () {
     const validationstate = this.props.validationstate || {}
  const profile = this.props.profile

  if (!profile?.investmentMinimums) {
    return null
  }
    const minimumLumpSum = profile.investmentMinimums.minimumLumpSum ??0
    const minimumMonthlyDebitOrder = profile.investmentMinimums.minimumMonthlyDebitOrder ??0
    const allowUnsureInvestors = profile.investmentMinimums.allowUnsureInvestors ?? false
    return <form className={styles['form-bottom-margin']}>
      <h4 className={styles['title']}>Investment Minimums</h4>
      <FieldGroup
        required
        type={'number'}
        value={minimumLumpSum}
        handleChange={this.handleMinimumLumpSumChange}
        label='Minimum lump sum'
        message={validationstate?.minimumLumpSum?.help}
        isInvalid={validationstate?.minimumLumpSum?.isInvalid} />
      <FieldGroup
        required
        type={'number'}
        value={minimumMonthlyDebitOrder}
        handleChange={this.handleMinimumMonthlyDebitOrderChange}
        label='Minimum monthly debit order'
        message={validationstate?.minimumMonthlyDebitOrder?.help}
        isInvalid={validationstate?.minimumMonthlyDebitOrder?.isInvalid} />
      <FormCheck
        type="checkbox"
        className={styles['inline-block'] || ''}
        checked={allowUnsureInvestors}
        onChange={() => this.handleToggleAllowUnsureInvestors(!allowUnsureInvestors)}
        label="I am willing to work with investors who are unsure how much they would like to invest."
      />

    </form>
  }

  render () {
    if (this.props.editing) {
      return this.renderEditor()
    }
    return this.renderPreview()
  }
}

const mapStateToProps = (state) => {
  return {
    editing: state.adviserProfileApprovalEditorContainer.investmentMinimums.editingInvestmentMinimums,
    loading: state.adviserProfileApprovalEditorContainer.investmentMinimums.loadingInvestmentMinimums,
    formIsValid: state.adviserProfileApprovalEditorContainer.investmentMinimums.isInvalid.formIsValid,
    validationstate: state.adviserProfileApprovalEditorContainer.investmentMinimums.isInvalid
  }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators({
    startEditing: startEditingInvestmentMinimums,
    stopEditing: stopEditingInvestmentMinimums,
    setMinimumLumpSum: setMinimumLumpSum,
    setMinimumMonthlyDebitOrder: setMinimumMonthlyDebitOrder,
    setAllowUnsureInvestors: setAllowUnsureInvestors,
    cancelEditingAdviserProfileInvestmentMinimums: cancelEditingAdviserProfileInvestmentMinimums
  }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)( (AdviserProfileInvestmentMinimumsEditor))
